module.exports = {
	"id": "KR",
	"name": "South Korea",
	"month": "2016-10",
	"access_date": "2016-11-03",
	"data": {
		"chrome": {
			"4": null,
			"5": null,
			"6": null,
			"7": null,
			"8": null,
			"9": null,
			"10": null,
			"11": 0.012782,
			"12": null,
			"13": null,
			"14": null,
			"15": null,
			"16": null,
			"17": null,
			"18": 0.012782,
			"19": null,
			"20": null,
			"21": null,
			"22": 0.006391,
			"23": null,
			"24": null,
			"25": null,
			"26": 0.006391,
			"27": 0.070301,
			"28": 0.006391,
			"29": 0.019173,
			"30": 0.006391,
			"31": 0.722183,
			"32": 0.012782,
			"33": 0.006391,
			"34": 0.012782,
			"35": null,
			"36": 0.012782,
			"37": 0.012782,
			"38": 0.012782,
			"39": 0.019173,
			"40": 0.006391,
			"41": 0.025564,
			"42": 0.172557,
			"43": 0.108647,
			"44": 0.051128,
			"45": 0.070301,
			"46": 0.031955,
			"47": 0.044737,
			"48": 0.095865,
			"49": 1.59775,
			"50": 0.146993,
			"51": 0.485716,
			"52": 0.402633,
			"53": 21.307594,
			"54": 5.675208,
			"55": 0.044737,
			"56": 0.025564,
			"57": null
		},
		"firefox": {
			"2": null,
			"3": 0.012782,
			"4": null,
			"5": null,
			"6": null,
			"7": null,
			"8": null,
			"9": null,
			"10": null,
			"11": null,
			"12": null,
			"13": null,
			"14": null,
			"15": null,
			"16": null,
			"17": null,
			"18": null,
			"19": null,
			"20": null,
			"21": 0.012782,
			"22": null,
			"23": null,
			"24": null,
			"25": null,
			"26": null,
			"27": null,
			"28": 0.006391,
			"29": null,
			"30": null,
			"31": null,
			"32": null,
			"33": null,
			"34": null,
			"35": null,
			"36": null,
			"37": 0.012782,
			"38": 0.012782,
			"39": null,
			"40": null,
			"41": null,
			"42": null,
			"43": 0.031955,
			"44": 0.012782,
			"45": 0.044737,
			"46": 0.044737,
			"47": 0.140602,
			"48": 0.089474,
			"49": 1.169553,
			"50": 0.038346,
			"51": null,
			"52": null,
			"3.5": 0.006391,
			"3.6": 0.031955
		},
		"opera": {
			"9": null,
			"11": null,
			"12": 0.019173,
			"15": null,
			"16": null,
			"17": null,
			"18": null,
			"19": null,
			"20": null,
			"21": null,
			"22": null,
			"23": null,
			"24": null,
			"25": null,
			"26": null,
			"27": null,
			"28": 0.012782,
			"29": null,
			"30": null,
			"31": null,
			"32": null,
			"33": null,
			"34": null,
			"35": null,
			"36": 0.025564,
			"37": 0.031955,
			"38": 0.051128,
			"39": null,
			"40": 0.115038,
			"41": 0.025564,
			"42": null,
			"43": null,
			"9.5-9.6": null,
			"10.0-10.1": 0,
			"10.5": null,
			"10.6": null,
			"11.1": null,
			"11.5": null,
			"11.6": 0.006391,
			"12.1": 0.025564
		},
		"safari": {
			"0": null,
			"4": 0.019173,
			"5": 0.019173,
			"6": 0.025564,
			"7": 0.031955,
			"8": 0.115038,
			"9": 0.121429,
			"10": 0.715792,
			"3.1": null,
			"3.2": null,
			"5.1": 0.057519,
			"6.1": 0.025564,
			"7.1": null,
			"9.1": 0.460152
		},
		"ios_saf": {
			"8": 0,
			"10": 4.09178743714,
			"3.2": 0,
			"4.0-4.1": 0,
			"4.2-4.3": 0,
			"5.0-5.1": 0,
			"6.0-6.1": 0,
			"7.0-7.1": 0.110268936719,
			"8.1-8.4": 0.203717188177,
			"9.0-9.2": 0.0971861815154,
			"9.3": 1.48271225645
		},
		"android": {
			"3": 0,
			"4": 0.032695751938,
			"53": null,
			"2.1": 0,
			"2.2": 0,
			"2.3": 0.00408696899225,
			"4.1": 0.117938248062,
			"4.2-4.3": 0.294845620155,
			"4.4": 0.67610144186,
			"4.4.3-4.4.4": 0.681939968992
		},
		"ie": {
			"6": 0.0385298358714,
			"7": 0.0449514751833,
			"8": 1.04672720784,
			"9": 1.38065245206,
			"10": 1.50266359898,
			"11": 18.7576084301,
			"5.5": null
		},
		"op_mob": {
			"0": 0.0069668822721,
			"10": 0,
			"11": 0,
			"12": 0,
			"11.1": 0,
			"11.5": 0,
			"12.1": 0.000193524507558
		},
		"edge": {
			"12": 0.025564,
			"13": 0.281204,
			"14": 1.163162
		},
		"ie_mob": {
			"10": 0.00426861971831,
			"11": 0.0173793802817
		},
		"bb": {
			"7": 0.00451,
			"10": null
		},
		"samsung": {
			"0": 10.232288
		},
		"and_uc": {
			"0": 0.248952
		},
		"op_mini": {
			"0": 0.0938635932203
		},
		"and_chr": {
			"0": 20.782311
		},
		"and_ff": {
			"0": 0.01804
		}
	},
	"total": 98.261284
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/caniuse-db/region-usage-json/KR.json
 ** module id = 567
 ** module chunks = 0
 **/